import Qs, { parse } from 'qs';
import { axiosClient, logging } from '../api/api';
import { IS_SERVER, LANDING_NAMES_BY_TYPE, API_URL, searchParam } from '../common';
import { setCookie } from '../helpers';

// export let logs = {};
export const path = !IS_SERVER && window.location.pathname;

export const KAFKA_TOPICS = {
  baseIdentityActions: 'base_identity_actions',
  navigation: 'navigation',
};

export const KAFKA_EVENT_TYPES = {
  launch: 'launch',
  registration: 'registration',
  authorization: 'authorization',
  identification: 'identification',
  navigation: 'navigation',
  common: 'common',
  promo: 'promo',
  login: 'login',
};

export const KAFKA_EVENT_CODES = {
  viewLanding: 'view_landing',
  clickRules: 'click_rules_landing',
  clickLogo: 'click_logo_landing',
  regStart: 'reg_start',
  enteredCharInReg: 'entered_char_in_reg',
  regButtonEnter: 'reg_button_enter',
  smsCodeEntered: 'sms_code_entered',
  smsCodeRepeat: 'sms_code_repeat',
  backStep: 'back_step',
  registrationDone: 'registration_done',
  enteredPhone: 'entered_phone',
  enteredEmail: 'entered_email',
  choseCountry: 'chose_country',
  choseСurrency: 'chose_currency',
  enteredPassword: 'entered_password',
  authStart: 'auth_start',
  fieldEntered: 'field_entered',
  bonusSelected: 'bonus_selected',
  continueButtonEnter: 'continue_button_enter',
  changePhoneButtonEnter: 'change_phone_button_enter',
  closePage: 'close_page',
  getFreebetsButtonEnter: 'get_freebets_button_enter',
  tgChannelButtonEnter: 'tg_channel_button_enter',
  rulesOpened: 'rules_opened',
  rulesClosed: 'rules_closed',
  clickOffer: 'click_offer',
  confirmNumberButtonEnter: 'confirm_number_button_enter',
  accountCreated: 'account_created',
  setupEmailInCupisRequest: 'setup_email_in_cupis_request',
  regOrAuthStart: 'reg_or_auth_start',
  startEnterSmsCode: 'start_enter_sms_code',
  authorizationDoneV2: 'authorization_done_v2',
  identificationStart: 'identification_start',
  smsCodeRequestRepeat: 'sms_code_request_repeat',
  fieldClickEdit: 'field_click_edit',
  confirmBirthDateButtonEnter: 'confirm_birth_date_button_enter',
};

export const KAFKA_LOGS_TREE = {
  [KAFKA_TOPICS.baseIdentityActions]: {
    [KAFKA_EVENT_TYPES.authorization]: [
      KAFKA_EVENT_CODES.authStart,
      KAFKA_EVENT_CODES.regOrAuthStart,
      KAFKA_EVENT_CODES.authorizationDoneV2,
    ],
    [KAFKA_EVENT_TYPES.registration]: [
      KAFKA_EVENT_CODES.regStart,
      KAFKA_EVENT_CODES.enteredCharInReg,
      KAFKA_EVENT_CODES.regButtonEnter,
      KAFKA_EVENT_CODES.smsCodeEntered,
      KAFKA_EVENT_CODES.smsCodeRepeat,
      KAFKA_EVENT_CODES.backStep,
      KAFKA_EVENT_CODES.registrationDone,
      KAFKA_EVENT_CODES.enteredPhone,
      KAFKA_EVENT_CODES.enteredEmail,
      KAFKA_EVENT_CODES.choseCountry,
      KAFKA_EVENT_CODES.choseСurrency,
      KAFKA_EVENT_CODES.enteredPassword,
      KAFKA_EVENT_CODES.bonusSelected,
      KAFKA_EVENT_CODES.continueButtonEnter,
      KAFKA_EVENT_CODES.accountCreated,
      KAFKA_EVENT_CODES.setupEmailInCupisRequest,
      KAFKA_EVENT_CODES.confirmBirthDateButtonEnter,
    ],
    [KAFKA_EVENT_TYPES.common]: [
      KAFKA_EVENT_CODES.fieldEntered,
      KAFKA_EVENT_CODES.closePage,
      KAFKA_EVENT_CODES.clickOffer,
      KAFKA_EVENT_CODES.confirmNumberButtonEnter,
      KAFKA_EVENT_CODES.fieldClickEdit,
    ],
    [KAFKA_EVENT_TYPES.login]: [
      KAFKA_EVENT_CODES.smsCodeEntered,
      KAFKA_EVENT_CODES.changePhoneButtonEnter,
      KAFKA_EVENT_CODES.startEnterSmsCode,
      KAFKA_EVENT_CODES.smsCodeRequestRepeat,
    ],
    [KAFKA_EVENT_TYPES.identification]: [KAFKA_EVENT_CODES.identificationStart],
  },
  [KAFKA_TOPICS.navigation]: {
    [KAFKA_EVENT_TYPES.common]: [
      KAFKA_EVENT_CODES.viewLanding,
      KAFKA_EVENT_CODES.regStart,
      KAFKA_EVENT_CODES.enteredPhone,
      KAFKA_EVENT_CODES.enteredEmail,
      KAFKA_EVENT_CODES.choseCountry,
      KAFKA_EVENT_CODES.choseСurrency,
      KAFKA_EVENT_CODES.enteredPassword,
    ],
    [KAFKA_EVENT_TYPES.promo]: [
      KAFKA_EVENT_CODES.clickRules,
      KAFKA_EVENT_CODES.clickLogo,
      KAFKA_EVENT_CODES.getFreebetsButtonEnter,
      KAFKA_EVENT_CODES.tgChannelButtonEnter,
      KAFKA_EVENT_CODES.rulesOpened,
      KAFKA_EVENT_CODES.rulesClosed,
    ],
  },
};

/**
 * Привести данные для отправки в Кафку к виду, который принимает бэк
 * @param {Object} data Данные для отправки
 * @return {string} Преобразованные данные
 */
const convertToData = (data) => Qs.stringify(data);

class KafkaLogger {
  defaultState = {};
  additionalData = {};
  imprint = null;
  pendingLogs = [];
  constructor() {
    if (typeof KafkaLogger.instance === 'object') {
      return KafkaLogger.instance;
    }
    KafkaLogger.instance = this;
    return KafkaLogger.instance;
  }

  async init() {
    try {
      const defaultParams = await axiosClient.get(`${API_URL}/ajax/account/data`);

      this.defaultState.date = Date();
      this.defaultState.ipAddress = defaultParams.data.result?.ip;
      this.defaultState.timezone = defaultParams.data.result?.timezone_id;
      this.defaultState.userAgent = navigator.userAgent;
      this.additionalData.appId = this.additionalData.appId ?? defaultParams.data.result?.appId;
      this.additionalData.appVer = defaultParams.data.result?.appVer;
      this.additionalData.sessionId = defaultParams.data.result?.sessionId;
      this.additionalData.host = window.location.hostname;
      this.additionalData.eventSource =
        this.additionalData.eventSource ?? defaultParams.data.result?.eventSource;
      if (defaultParams.data.result?.login) {
        this.defaultState.login = defaultParams.data.result.login;
      }

      // TODO: Вынести в будущем /ajax/account/data и выполнять отдельно от Logger
      setCookie('True-Client-Ip', defaultParams.data.result?.ip || '');
      setCookie('version', defaultParams.data.result?.appVer || '');
    } catch (error) {
      console.error('Error initializing KafkaLogger:', error);
    }
  }

  setImprint(imprint) {
    this.imprint = imprint;

    const pendingLogs = this.pendingLogs;
    this.pendingLogs = [];
    pendingLogs.forEach(({ eventCode, detail }) => this.add(eventCode, detail));
  }

  setAppId(appId) {
    this.additionalData.appId = appId;
  }

  setEventSource(eventSource) {
    this.additionalData.eventSource = eventSource;
  }

  /**
   * Добавление события логирования в объект для отправки
   * @param eventCode
   * @param detail
   */
  add = (eventCode, detail) => {
    if (this.imprint === null) {
      this.pendingLogs.push({ eventCode, detail });
      return;
    }

    const { log, topic } = this.buildLogInfoByEventCode(eventCode, detail);
    if (!log) return;
    const logs = {
      [topic]: {
        action: log,
        additional_data: {
          ...this.additionalData,
          imprintHash: this.imprint,
        },
      },
    };
    this.send(logs);
  };

  /**
   * Отправка данных на сервер (только на проде)
   * @return {null}
   */
  send = (logs) => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    const topics = Object.keys(logs);
    topics.forEach((topic) => {
      const { action, additional_data } = logs[topic] || {};
      const actionLength = Object.keys(action).length;
      if (actionLength > 0) {
        const log = {
          topic,
          action,
          additional_data,
        };
        const data = convertToData(log);
        logging(data);
      }
    });
  };

  sendLog(eventName, objectData) {
    const data = { ...this.defaultState, ...objectData };
    this.send(data);
  }

  /**
   * Построение объекта с информацией о логе по EventCode
   * @param eventCode
   * @param detail
   * @return {{log: {eventCode, datetime: string, eventType}, topic}}
   */
  buildLogInfoByEventCode = (eventCode, detail) => {
    let info = {};
    //Обходим топики
    Object.keys(KAFKA_LOGS_TREE).find((topic) =>
      // Обходим типы событий
      Object.keys(KAFKA_LOGS_TREE[topic]).find((eventType) => {
        // Ищем событие
        const eventCodes = KAFKA_LOGS_TREE[topic][eventType];
        const isEventCodeFound = eventCodes.includes(eventCode);

        if (isEventCodeFound) info = { topic, eventType };

        return isEventCodeFound;
      }),
    );

    const { topic, eventType } = info;
    const isTopicAndEventTypeExist = topic && eventType;
    const log = {
      eventType,
      eventCode,
      ...(detail && { detail }),
      ...this.defaultState,
    };

    return isTopicAndEventTypeExist ? { topic, log } : {};
  };
}

export const Logger = new KafkaLogger();

/**
 * Отправка логов в Кафку при открытии лендинга
 */
export const logForOpenPage = (refer, imprint) => {
  if (IS_SERVER) return;
  const { viewLanding } = KAFKA_EVENT_CODES;

  const pathWithFinalSlash = path.endsWith('/') ? path : `${path}/`;
  const pathArr = pathWithFinalSlash.split('/');
  const lang = pathArr.find((item) => item.length === 2);
  const name = pathArr[pathArr.length - 2]; // откидываем финальный слеш урла
  const isCasinoInPath = pathArr.find((item) =>
    item?.split('_')?.find((item) => item.startsWith('casino')),
  );
  const isTypeCasino =
    LANDING_NAMES_BY_TYPE.casino.includes(name) ||
    LANDING_NAMES_BY_TYPE.tournament.casino.includes(name) ||
    isCasinoInPath;
  const isTypeAnother = LANDING_NAMES_BY_TYPE.another.includes(name);
  const type = isTypeCasino ? 'casino' : isTypeAnother ? 'another' : 'sport';
  const getParameters = parse(window.location.search, { ignoreQueryPrefix: true });
  const partnerUid = getParameters['zpartner_uid'];
  const params = window.location.search;
  // используем нулевое слияние, т.к. у нас 2 вида ссылок
  const subId = searchParam('subid') ?? searchParam('sub_id');

  Logger.add(
    viewLanding,
    {
      partnerUid,
      sourceScreen: path + params,
      language: lang,
      refer,
      type,
      name,
      subId,
    },
    imprint,
  );
};

/**
 * Отправка логов в Кафку при клике на правила
 */
export const logForClickRules = (imprint) => {
  if (IS_SERVER) return;
  const { clickRules } = KAFKA_EVENT_CODES;

  Logger.add(
    clickRules,
    {
      sourceScreen: path,
    },
    imprint,
  );
};

/**
 * Отправка логов в Кафку при клике на логотип
 */
export const logForClickLogo = (imprint) => {
  if (IS_SERVER) return;
  const { clickLogo } = KAFKA_EVENT_CODES;

  Logger.add(
    clickLogo,
    {
      sourceScreen: path,
    },
    imprint,
  );
};
